import { H2 } from '@liveauctioneers/hammer-ui-core/text';

import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

export const SecurityFormHeader = () => {
    const formatMessage = useAppFormatMessage();
    return (
        <header className="mb-sm flex">
            <H2>{formatMessage(['accountSettings', 'security', 'header'])}</H2>
        </header>
    );
};
